import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"],
  _excluded2 = ["options", "buttonUse", "tooltipHeadingText", "tooltipText", "dropdownFooter", "value", "onChange", "clearable", "itemComponent", "useDefaultValueComponent", "formControlLabel"];
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Select } from 'foundations-components/transitional/components/Select';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledMetricSelectedPropertyItem = _ref => {
  let {
      children,
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      placement: "right",
      title: option.text,
      disabled: !option.text,
      children: children
    })
  }));
};
const BaseSelectComponent = _ref2 => {
  let {
      options,
      buttonUse,
      tooltipHeadingText,
      tooltipText,
      dropdownFooter,
      value,
      onChange,
      clearable,
      itemComponent,
      useDefaultValueComponent = true,
      formControlLabel
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  if (tooltipText) {
    return /*#__PURE__*/_jsx(FormControl, {
      label: formControlLabel,
      children: /*#__PURE__*/_jsx(Tooltip, {
        headingText: tooltipHeadingText,
        title: tooltipText,
        children: /*#__PURE__*/_jsx(Select, Object.assign({}, rest, {
          clearable: clearable,
          itemComponent: itemComponent,
          dropdownFooter: dropdownFooter,
          menuWidth: "auto",
          onChange: onChange,
          options: options,
          paddingInlineStart: buttonUse === 'transparent' ? '0' : undefined,
          value: value,
          valueComponent: useDefaultValueComponent ? StyledMetricSelectedPropertyItem : undefined
        }))
      })
    });
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: formControlLabel,
    children: /*#__PURE__*/_jsx(Select, Object.assign({}, rest, {
      clearable: clearable,
      itemComponent: itemComponent,
      dropdownFooter: dropdownFooter,
      menuWidth: "auto",
      onChange: onChange,
      options: options,
      paddingInlineStart: buttonUse === 'transparent' ? '0' : undefined,
      value: value,
      valueComponent: useDefaultValueComponent ? StyledMetricSelectedPropertyItem : undefined
    }))
  });
};
export default BaseSelectComponent;